export default __webpack_public_path__ + "static/media/nydig_logo.e2d457d4.png";